import { createElement, useEffect, useMemo } from 'react';
import { PageController, setCredentials } from '@sitecore-search/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { init } from './setup.js';
let queryClient;
export const getQueryClient = (client) => {
    if (!queryClient && client) {
        queryClient = client;
    }
    else if (!queryClient) {
        queryClient = new QueryClient({
            defaultOptions: {
                queries: {
                    retry: false,
                    keepPreviousData: true,
                    refetchOnWindowFocus: false,
                },
            },
        });
    }
    return queryClient;
};
const WidgetsProvider = ({ apiKey, children, clientId, customerKey, debug, discoverDomainId, env = 'prod', orderCloudRegion, publicSuffix = false, requestMiddleware, serviceHost, trackConsent = true, uri, useAccessToken, useStorage, useToken, ...props }) => {
    useMemo(() => {
        setCredentials({
            apiKey,
            clientId,
            customerKey,
            debug,
            discoverDomainId,
            env,
            orderCloudRegion,
            publicSuffix,
            requestMiddleware,
            serviceHost,
            trackConsent,
            useAccessToken,
            useStorage,
            useToken,
        });
        init({ uri, autoIncludeWidgets: false, autoIncludeNewWidgets: false });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // We need to check the consent for tracking on every consent change on the provider.
    useEffect(() => {
        PageController.toggleTrackConsent(trackConsent);
    }, [trackConsent]);
    return createElement(QueryClientProvider, {
        ...props,
        client: getQueryClient(props.client),
    }, children);
};
export const OrderCloudSearchProvider = ({ discoverDomainId, orderCloudRegion, searchEnv = 'prod', requestMiddleware, searchApiKey, publicSuffix, trackConsent = true, ...props }) => {
    return WidgetsProvider({
        discoverDomainId,
        orderCloudRegion,
        publicSuffix,
        requestMiddleware,
        env: searchEnv,
        apiKey: searchApiKey,
        trackConsent,
        ...props,
    });
};
export default WidgetsProvider;
